export const getFriendlyFirebaseMessage = (error) => {
	if (!error || typeof error !== "string") {
		return "auth/none";
	}

	// Extrai o código de erro entre parênteses
	const match = error.match(/\((auth\/[^)]+)\)/);
	const code = match ? match[1] : null;

	const friendlyMessages = {
		"auth/none": "auth/none",
		"auth/invalid-phone-number": "auth/invalid-phone-number",
		"auth/missing-phone-number": "auth/missing-phone-number",
		"auth/operation-not-allowed": "auth/operation-not-allowed",
		"auth/quota-exceeded": "auth/quota-exceeded",
		"auth/too-many-requests": "auth/too-many-requests",
		"auth/code-expired": "auth/code-expired",
		"auth/invalid-verification-code": "auth/invalid-verification-code",
		"auth/user-disabled": "auth/user-disabled",
		"auth/network-request-failed": "auth/network-request-failed",
		"auth/internal-error": "auth/internal-error",
		"auth/app-not-authorized": "auth/app-not-authorized",
		"auth/session-expired": "auth/session-expired",
	};

	return friendlyMessages[code] || "auth/none";
};
